import { PRODUCTION, DEVELOPMENT, S_K_DEV } from "./const";
import { isEmpty } from "lodash";

export function getSKey() {
  const REACT_ENV = process.env.NODE_ENV;
  const S_K = !!process.env.REACT_APP_S_K && process.env.REACT_APP_S_K !== "" ? process.env.REACT_APP_S_K : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return S_K_DEV;
      case PRODUCTION:
        return S_K;
      default:
        return S_K_DEV;
    }
  } else {
    return S_K_DEV;
  }
}

export const getSKeyValue = () => {
  return getSKey();
};
